import Home from "./views/Home.vue";
import NotImplemented from "./components/NotImplemented.vue";
import type { RouterOptions } from "vue-router";
import { NotAuthorized, NotFound, PasswordChanged } from "@modernary/mui/components/common";
import formSubmissionRoutes, { formSubmissionRouteNames } from "./views/formSubmission/formSubmissionRoutes";
import facilityRoutes, { facilityRouteNames } from "./views/facility/facilityRoutes";
import wellRoutes, { wellRouteNames } from "./views/well/wellRoutes";
import permitRoutes, { permitRouteNames } from "./views/permit/permitRoutes";

// Troubleshoot your routes using this - https://paths.esm.dev

export const routeNames = {
  home: "Home",
  passwordChanged: "PasswordChanged",
  notAuthorized: "NotAuthorized",
  notImplemented: "NotImplemented",
  formSubmission: {
    ...formSubmissionRouteNames,
  },
  facility: {
    ...facilityRouteNames,
  },
  well: {
    ...wellRouteNames,
  },
  permit: {
    ...permitRouteNames,
  },
};

export const routes: RouterOptions["routes"] = [
  { path: "/", component: Home, name: routeNames.home, meta: { title: "Home" } },
  {
    path: "/password-changed",
    component: PasswordChanged,
    name: routeNames.passwordChanged,
    meta: { title: "Password Changed" },
  },
  {
    path: "/unauthorized",
    component: NotAuthorized,
    name: routeNames.notAuthorized,
    meta: { title: "Not Authorized" },
  },
  {
    path: "/not-implemented",
    component: NotImplemented,
    name: routeNames.notImplemented,
    meta: { title: "Not Implemented" },
  },
  { path: "/:path(.*)", component: NotFound },
  ...formSubmissionRoutes,
  ...facilityRoutes,
  ...wellRoutes,
  ...permitRoutes,
];
